import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Loader } from 'components';
import { useReduxSelector, useReduxDispatch } from 'store/hooks';
import { checkLogin } from 'store/account';
import Login from 'login/Login';
import Header from './Header';
import Sidebar from './Sidebar';
import Content from './Content';
import { fetchEnv } from 'store/app';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    height: '100vh',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex'
  }
});

const Main = () => {
  const classes = useStyles();
  const account = useReduxSelector((state) => state.account);
  const app = useReduxSelector((state) => state.app);
  const location = useLocation();
  const callCheckLogin = useReduxDispatch(checkLogin);
  const getEnv = useReduxDispatch(fetchEnv);

  useEffect(() => {
    getEnv();
  }, [])

  useEffect(() => {
    if (!app.env) return;
    else {
      const favicon = document.getElementById('favicon');
      favicon.href = app.env.faviconUri;
      document.title = app.env.hospitalName;
    }

    if (account.isCheckLoginIdle || account.isSignInReady) {
      callCheckLogin();
    }
  }, [app.env, account.isCheckLoginIdle, account.isSignInReady]);

  useEffect(() => {
    return () => null
  }, [location.pathname, account.isCheckLoginIdle, account.isSignInReady, account.data?.isSPV])

  if (app.isReady) {
    if (account.data) {
      return (
        <div className={classes.root}>
          <Header />
          <Sidebar />
          <Content />
        </div>
      );
    } else if (account.isCheckLoginFetching) {
      return <Loader height='page' variant='rotate' />;
    } else {
      return <Login />;
    }
  } else {
    return <Loader height='page' variant='rotate' />;
  }
};

export default Main;
